import { render, staticRenderFns } from "./Games.vue?vue&type=template&id=f689ff84&scoped=true&"
import script from "./Games.vue?vue&type=script&lang=ts&"
export * from "./Games.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f689ff84",
  null
  
)

export default component.exports